export default String.raw`
$fontFamily: #{'{{settings.fontFamily}}'};
$iconWeight: #{'{{settings.iconStyle}}'};

$btnSolidBgColor: #{'{{settings.btnSolidBgColor}}'};
$btnSolidTextColor: #{'{{settings.btnSolidTextColor}}'};
$btnSolidHoverBgColor: #{'{{settings.hoverOverButton}}'};
$btnSolidHoverTextColor: #{'{{settings.btnSolidHoverTextColor}}'};

$secondaryBtnBgColor: #{'{{settings.secondaryBtnBgColor}}'};
$secondaryBtnFontColor: #{'{{settings.secondaryBtnFontColor}}'};
$secondaryBtnBorderColor: #{'{{settings.secondaryBtnBorderColor}}'};
$secondaryBtnHoverBgColor: #{'{{settings.secondaryBtnHoverBgColor}}'};
$secondaryBtnHoverFontColor: #{'{{settings.secondaryBtnHoverFontColor}}'};
$secondaryBtnHoverBorderColor: #{'{{settings.secondaryBtnHoverBorderColor}}'};

$iconColors: #{'{{settings.iconColors}}'};
$iconColorsHover: #{'{{settings.iconColorsHover}}'};
$hoverOverButton: #{'{{settings.hoverOverButton}}'};
$lightBorderColor: #{'{{settings.lightBorderColor}}'};
$bgColor: #{'{{settings.bgColor}}'};
$bgColorAlphaStart: #{'{{settings.bgColor}}cc'};
$bgColorAlphaEnd: #{'{{settings.bgColor}}00'};
$primaryColor: #{'{{settings.primaryColor}}'};
$secondaryColor: #{'{{settings.secondaryColor}}'};
$lightestColor: #{'{{settings.lightestColor}}'};
$lighterColor:#{'{{settings.lighterColor}}'};
$middleColor: #{'{{settings.middleColor}}'};
$focusVisibleColor: #{'{{settings.focusVisibleColor}}'};

$primaryColorFont: #{'{{settings.primaryColorFont}}'};
$secondaryColorFont: #{'{{settings.secondaryColorFont}}'};
$bgColorFont: #{'{{settings.bgColorFont}}'};
$lightestColorFont: #{'{{settings.lightestColorFont}}'};
$lighterColorFont:#{'{{settings.lighterColorFont}}'};
$middleColorFont: #{'{{settings.middleColorFont}}'};

$ribbonTextColor: #{'{{settings.ribbonTextColor}}'};
$ribbonPromotion: #{'{{settings.ribbonPromotion}}'};
$ribbonBestRated: #{'{{settings.ribbonBestRated}}'};
$ribbonNewProduct:#{'{{settings.ribbonNewProduct}}'};
$ribbonRecommendedProduct: #{'{{settings.ribbonRecommendedProduct}}'};
$ribbonPromotionalProduct: #{'{{settings.ribbonPromotionalProduct}}'};
$ribbonVendorRecomendation:#{'{{settings.ribbonVendorRecomendation}}'};
$ribbonGreatPrice: #{'{{settings.ribbonGreatPrice}}'};
$ribbonGreatQuality: #{'{{settings.ribbonGreatQuality}}'};
$ribbonSale: #{'{{settings.ribbonSale}}'};
$ribbonReward: #{'{{settings.ribbonReward}}'};

$dangerColor: #{'{{settings.errorColor}}'};
$warnColor: #{'{{settings.warningColor}}'};
$warnColorHover: #{'{{settings.warningColorHover}}'};
$infoColor: #{'{{settings.infoColor}}'};
$successColor: #{'{{settings.successColor}}'};

$menuBackgroundColor: #{'{{settings.menuBackgroundColor}}'};
$menuBorderColor: #{'{{settings.menuBorderColor}}'};
$menuIconsAndFontColor: #{'{{settings.menuIconsAndFontColor}}'};
$menuIconsAndFontColorHover: #{'{{settings.menuIconsAndFontColorHover}}'};

$textElementBg: #{'{{settings.textElementBg}}'};
$textElementFont: #{'{{settings.textElementFont}}'};

//kolory w formach
$formsBgColor: #{'{{settings.formsBgColor}}'};

//footer background
$footerColorBackground: #{'{{settings.footerColorBackground}}'};

//footer kolor używany do zawartości footera
$footerColorLinks: #{'{{settings.footerColorLinks}}'};
$footerColorFont: #{'{{settings.footerColorFont}}'};  // #99c0d4  kolor używany do pozostałej zawartości footera (np. prawa autorskie)
$footerBannerBackground: #{'{{settings.footerBannerBackground}}'};

//border color of active element
$activeBgColor: $primaryColor;

/* inputs */
$inputsBgColor: #{'{{settings.inputsBgColor}}'};
$inputsBorderColor: #{'{{settings.inputsBorderColor}}'};
$inputsHoverColor: #{'{{settings.inputsHoverColor}}'};

/* categories navigation */
$category-column-width: 320px;
$categoriesItemHeight: 55px;

$categoriesBgColor: $bgColor;

$categoriesLinksBg: $menuBackgroundColor;
$categoriesLinksText: #272727;
$categoriesLinksHoverBg: $primaryColor;
$categoriesLinksHoverText: #fff;

$categoriesArrowsBg: #F6F6F6;
$categoriesArrowsColor: #272727;
$categoriesArrowsHoverBg: $primaryColor;
$categoriesArrowsHoverColor: #fff;

$categoriesActiveColor: $activeBgColor;

$btnOutlineColor: $primaryColor;
$btnOutlineHoverTextColor: #FFF;
$btnActiveOutline: $primaryColor;

$btnDisabledBg: #dad5d5;
$btnDisabledFont: #eeeeee;

$btnGrayBg: #f0f0f0;
$btnGrayFont: $primaryColorFont;
$btnGrayBorder: $lightBorderColor;

$menuArrowsBgColor: $categoriesArrowsBg;

/* compare products */
$table-cell-width: 12px;
$table-cell-height: 12px;
$table-column-width: 25%;
$table-first-column-left: 24px;

$compareProductsBarBg: #f6f6f6;
$deleteFromComparison: #7FBA01;
$deleteFromComparisonSite: #004B88;

/* page structure */
$headerMiddleBarHeight: 142px;
$headerTopBarHeight: 41px;
$navigationBarHeight: 63px;

//cart buttons
$lowerPriceAndCart: #{'{{settings.lowerPriceAndCart}}'};
$lowerPriceAndCartFont: #{'{{settings.lowerPriceAndCartFont}}'};
$cartButtonHover: #{'{{settings.cartButtonHover}}'}; //#68a204
$cartButtonHoverFont: #{'{{settings.cartButtonHoverFont}}'}; //#68a204
$topButtonHover: $cartButtonHover;
$topButtonArrowColor: #fff;

//niższa cena
$nettoPrice: $lowerPriceAndCart;

/* mechanics and animations */
$animations-time: 800ms;
$short-animations-time: 300ms;

/* --- components ---- */

//checkboxes
$checkboxes: #{'{{settings.secondaryColor}}'};

$standardCheckboxBorder: $inputsBorderColor;
$standardCheckboxBg: $inputsBgColor;

$standardCheckboxActiveBg: $checkboxes;
$standardCheckboxActiveCheck: $inputsBgColor;

$invertedCheckboxActiveBg: $inputsBgColor;
$invertedCheckboxActiveCheck: $checkboxes;

//radios
$radioBg: $lightBorderColor;

$radioActiveBg: $lighterColor;
$radioActiveCheck: $inputsBgColor;

/* no image icon */
$noImageColor: $lightBorderColor;

/* basic dropdowns (dropdowns from init.js) */
$dropContainerShadowColor: #ddd;
$dropContainerBgColor: $bgColor;

/* miniboxes */
$miniboxHeight: 380px;
$miniboxCaptionHeight: 135px;
$miniboxMargin: 5px;
$miniboxPadding: 10px;

/* waiting circle */
$waitingCircleTrack: $primaryColor;
$waitingCircleSpiner: #fff;
$waitingCircleWidth: 0.4rem;
$waitingCircleSize: 3rem;
$waitingCircleBigSize: 5rem;

/* newsletter */
$newsletterBgColor: #{'{{settings.newsletterBgColor}}'};
$newsletterFont: #{'{{settings.newsletterFont}}'};

/* header */
$headerIconsAndFontColor: #{'{{settings.headerIconsAndFontColor}}'};
$headerIconsAndFontColorHover: #{'{{settings.headerIconsAndFontColorHover}}'};
$headerCounterBgColor: #{'{{settings.headerCounterBgColor}}'};
$headerCounterBgColorHover: #{'{{settings.headerCounterBgColorHover}}'};
$headerCounterFontColor: #{'{{settings.headerCounterFontColor}}'};
$headerCounterFontColorHover: #{'{{settings.headerCounterFontColorHover}}'};
$headerCartIconAndFontColor: #{'{{settings.headerCartIconAndFontColor}}'};
$headerCartIconAndFontColorHover: #{'{{settings.headerCartIconAndFontColorHover}}'};

/* stepper */
$stepperHeight: 40px;
$stepperFontColor: $primaryColorFont;
$stepperButtonsBg: #f6f6f6;
$stepperButtonsHover: $primaryColor;

/* tables */
$tableHeaderBgColor: #F6F6F6;
$tableHeaderHeight: 60px;
$stripesBgColor: #f8f8f8;
$tableBorderColor: $lightBorderColor;
$tableHeaderSeparatorColor: #c6c6c6;
$linkedRowHover: #cfd6da;

/* tooltips */
$tooltipIconBg: $primaryColor;
$toolitpIconColor: #fff;
$tooltipBoxBg: #fff;
$tooltipBoxColor: $primaryColorFont;
$tooltipBorderColor: $primaryColor;
$tooltipArrowSize: 10px;

/* tooltips and modals */
$modalTooltipShadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.11);

/* ---- pages ---- */

/* product list */
$linesOfDescription: 3;
$viewButtonsBg: #f8f8f8;

$imageWidthOnList: 260px;
$priceColumnWidthOnList: 200px;


$gridItemHeight: 470px;
$gridItemSpacing: 30px;
$gridColumns: 2;

$gridAndListHoverShadowColor: #c5c5c5;

$filtersBgColor: #F6F6F6;
$filtersButtonHeight: 45px;
$openedFiltersSectionBg: #fff;

$selectedFilterButtonBg: #f8f8f8;

$searchPhraseMark: #fdd835;
$searchPhraseButtonHover: #FFF59D;

/* product details */
$addToCartContainerBg: #f6f6f6;
$changeCartArrowsBg: #d1e5a5;
$productPresentationMenuBg: $bgColor;
$savedMoney: #ef5350;
$attributesButtonBg: $bgColor;
$attributesButtonFont: $primaryColorFont;

// swiper slider
$disabledArrow: #ddd;

/* message bars and texts */
$messageBarFont: #{'{{settings.alertsTextColor}}'};

// customer profile
$customerProfileHeaderMenuFont: #fff;
$customerProfileHeaderMenuBg: $primaryColor;
$customerProfileHeaderMenuBorder: #4089ae;
$customerProfileHeaderMenuButtonHover: $hoverOverButton;
$customerProfileHeaderMenuFontActive: $customerProfileHeaderMenuBg;
$customerProfileHeaderMenuBgActive: $customerProfileHeaderMenuFont;
$customerProfileHeaderMenuBorderActive: $customerProfileHeaderMenuBg;
$menuTabBg: $btnGrayBg;
$menuTabBgActive: $bgColor;
$customerProfileButtonFont: $primaryColor;
$customerProfileButtonBg: #fff;
$customerProfileButtonFontActive: $customerProfileButtonBg;
$customerProfileButtonBgActive: $customerProfileButtonFont;
$rightTilePartBg: $menuArrowsBgColor;
$orderExecuted: #7fba00;
$orderCanceled: #ef5350;
$discountColor: #ef5350;
$overallPriceColor: $primaryColor;
$labelsColor: #696666;

/* cart */
$cartNavigationBarBg: $lowerPriceAndCart;
$cartNavigationHoverBg: $cartButtonHover;
$cartNavigationFont: #fff;

$cartNavigationActiveBg: #fff;
$cartNavigationActiveFont: $primaryColorFont;

$iconColumnWidth: 60px;
$priceLikeColumnWidth: 95px;
$percentColumnWidth: 75px;
$stepperColumnWidth: 270px;
$currencyColumnWidth: 80px;

$couponBoxBg: none;

$optionsSectionBg: #F8f8f8;

$cartOptionBoxBg: #fff;
$cartOptionBorderColor: $lightBorderColor;

$thankYouBoxesBg: #f8f8f8;

$collectionPointActiveBorder: $primaryColor;
$collectionPointHoverBg: $primaryColor;
$collectionPointHoverFont: #fff;

/* editing order stuff */
$editingOrderPrimaryColor: $primaryColor;
$editingOrderPrimaryHoverColor: $hoverOverButton;
$editingOrderBarFontColor: $lightestColorFont;

$editedPositionColor: $warnColor;

$duringEditionMessageHeight: 55px;

/* Other */
$breadcrumbsAndSomeLists: #{'{{settings.fontColorGreyBar}}'}; //#717171 used for styling current page on breadcrumbs, oldprice
$greyBarIcon: #{'{{settings.iconColorGreyBar}}'};
$breadcrumbs: #767676;
$dateOfPublication: #767676;
$activeTab: #fff;
$headerphoneAndMail: #717171;
$formLabel: #717171;
$advancedSearchPriceStripe: #fbfbfb;
$cookieNoticeBackground: #F8F8F8;
$topBorderColor: $primaryColor; // used in menu as active-tab
$cartButton: $lowerPriceAndCart;
$emptyCartIcon: #d2d2d2;
$productsListLabels: #7b7878;
$topBannerBgColor: #{'{{settings.topBannerBgColor}}'};
$topBannerFontColor: #{'{{settings.topBannerFontColor}}'};
$topBannerFontHoverColor: #{'{{settings.topBannerFontHoverColor}}'};
$bgColorLogo: #{'{{settings.colorBackgroundLogo}}'};

$bannerFontColor: #{'{{settings.bannerFontColor}}'};
$bannerSecondaryFontColor: #{'{{settings.bannerSecondaryFontColor}}'};
$bannerBtnFontColor: #{'{{settings.bannerBtnFontColor}}'};
$bannerBtnBgColor: #{'{{settings.bannerBtnBgColor}}'};
$bannerBtnBorderColor: #{'{{settings.bannerBtnBorderColor}}'};
$bannerBtnHoverFontColor: #{'{{settings.bannerBtnHoverFontColor}}'};
$bannerBtnHoverBgColor: #{'{{settings.bannerBtnHoverBgColor}}'};
$bannerBtnHoverBorderColor: #{'{{settings.bannerBtnHoverBorderColor}}'};
$bannerTextFieldColor: #{'{{settings.bannerTextFieldColor}}'};
$bannerTimerBgColor: #{'{{settings.bannerTimerBgColor}}'};
$bannerTimerBorderColor: #{'{{settings.bannerTimerBorderColor}}'};
$bannerTimerFontColor: #{'{{settings.bannerTimerFontColor}}'};
$bannerTimerNumbersColor: #{'{{settings.bannerTimerNumbersColor}}'};
$bannerPromotionalFontColor: #{'{{settings.bannerPromotionalFontColor}}'};
$activeListIconBackgroundColor: #{'{{settings.activeListIconBackgroundColor}}'};
$activeListIconColor: #{'{{settings.activeListIconColor}}'};
$inactiveListIconColor: #{'{{settings.inactiveListIconColor}}'};
`